export default __webpack_public_path__ + "static/media/landscape26.eac07d9b.JPG";